import React from 'react'
import {SpaceProto} from "../../../../core/model2/space/space-proto";
import {UIType} from "../../../ui/@const";

type Props = {
    space                   : SpaceProto,
    className?              : string
    children?               : any
}

export default function NavigationMenu_TopHeader(props: Props) {

    return (
        <div className={Classes("flex-row-between-center", props.className, {
            // "top-header"            : gd.ui.type === UIType.LEFT || gd.ui.type === UIType.TOP || gd.ui.type === UIType.GOODDAY_MODERN,
            "top-header"            : gd.ui.type !== UIType.TEAMS && gd.ui.type !== UIType.CLICK_UP,
            "top-header-teams"      : gd.ui.type === UIType.TEAMS,
            "top-header-click-up"   : gd.ui.type === UIType.CLICK_UP
        })}>
            <div className="ui5-title-app-name p-l-20 no-wrap">
                {props.space.title}
            </div>

            {props.children &&
                <div className="left-nav-space-controls">
                    {props.children}
                </div>
            }

        </div>
    )
}
